import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import formatTime from 'utils/formatTime';
import formatTimeInTimezone from 'utils/formatTimeInTimezone';
import getTimezoneByStockPlace, {
  getTimezoneAbbr,
} from 'utils/getTimezoneByStockPlace';

dayjs.extend(utc);
dayjs.extend(timezone);

type DualTimezoneTimeProps = {
  time?: string | null;
  stockPlace?: string;
};

const DualTimezoneTime = ({ time, stockPlace }: DualTimezoneTimeProps) => {
  const localStr = formatTime(time);

  if (!time || localStr === '-') {
    return <span>{localStr}</span>;
  }

  const warehouseTz = getTimezoneByStockPlace(stockPlace);
  const localTz = dayjs.tz.guess();
  const showDual = !!warehouseTz && warehouseTz !== localTz;

  if (!showDual) {
    return <span className="text-black">{localStr}</span>;
  }

  const warehouseStr = formatTimeInTimezone(time, warehouseTz);
  const localTzAbbr = getTimezoneAbbr(localTz);
  const warehouseTzAbbr = getTimezoneAbbr(warehouseTz);

  return (
    <div className="leading-tight">
      <div className="text-black">
        {localStr}
        {localTzAbbr ? ` (${localTzAbbr})` : ''}
      </div>
      <div className="text-xs text-red-500 font-bold mt-0.5">
        {warehouseStr}
        {warehouseTzAbbr ? ` (${warehouseTzAbbr})` : ''}
      </div>
    </div>
  );
};

export default DualTimezoneTime;
